import { SelectOption } from '~globals/types';
import { PreferencesTrackingComplaintChannelTypeId } from '~globals/types/enums';

export const trackingComplainTypes: SelectOption[] = [
  {
    value: String(PreferencesTrackingComplaintChannelTypeId.None),
    label: 'Sin canal de comunicación',
  },
  {
    value: String(PreferencesTrackingComplaintChannelTypeId.Email),
    label: 'Correo electrónico',
  },
  {
    value: String(PreferencesTrackingComplaintChannelTypeId.Whatsapp),
    label: 'Whatsapp',
  },
];
